import { Button, ButtonGroup, Cell, FormControl, Grid, Text, VFlow } from 'bold-ui'
import { FieldArray, resolveName } from 'components/form'
import { useState } from 'react'
import { MetaRoot } from 'util/metaPath'

import { AnexoArquivoFormModel, EstadoBotaoExamesEnum, ResultadoExameAnexoFormModel } from '../../model-anexoArquivos'
import { ExamesNaoSolicitadosForm } from './ExamesNaoSolicitadosForm'
import { ExamesSolicitadosForm } from './ExamesSolicitadosForm'

interface ArquivoResultadoExameButtonGroupProps {
  name: MetaRoot<AnexoArquivoFormModel>
}

export function ArquivoResultadoExameButtonGroup(props: Readonly<ArquivoResultadoExameButtonGroupProps>) {
  const { name } = props
  const [estadoBotaoExames, setEstadoBotaoExames] = useState<EstadoBotaoExamesEnum>(EstadoBotaoExamesEnum.SOLICITADO)
  const isSolicitado = estadoBotaoExames === EstadoBotaoExamesEnum.SOLICITADO

  return (
    <FormControl label='Vincular resultados de exame ao anexo de arquivo' required>
      <Grid>
        <Cell size={12}>
          <VFlow vSpacing={0.5}>
            <Text>Para cada exame vinculado ao arquivo será gerado um registro de resultado de exame.</Text>
            <ButtonGroup>
              <Button
                kind={isSolicitado ? 'primary' : 'normal'}
                size='small'
                skin='default'
                onClick={() => setEstadoBotaoExames(EstadoBotaoExamesEnum.SOLICITADO)}
              >
                Solicitado
              </Button>
              <Button
                kind={!isSolicitado ? 'primary' : 'normal'}
                size='small'
                skin='default'
                onClick={() => setEstadoBotaoExames(EstadoBotaoExamesEnum.NAO_SOLICITADO)}
              >
                Não solicitado
              </Button>
            </ButtonGroup>
          </VFlow>
        </Cell>
        <Cell style={{ display: isSolicitado ? 'block' : 'none' }} size={12}>
          <FieldArray<ResultadoExameAnexoFormModel>
            name={resolveName(name.resultadosComSolicitacao)}
            render={() => <ExamesSolicitadosForm name={name} />}
          />
        </Cell>
        <Cell style={{ display: !isSolicitado ? 'block' : 'none' }} size={12}>
          <FieldArray<ResultadoExameAnexoFormModel>
            name={resolveName(name.resultadosSemSolicitacao)}
            render={() => <ExamesNaoSolicitadosForm name={name} />}
          />
        </Cell>
      </Grid>
    </FormControl>
  )
}
